<template>

    <div class="credit-proposal-information-component">

        <!-- Introduction -->
        <div class="introduction">
            <div class="row">
                <div class="col-12">
                    <h3>{{ sectionThreeHeading }}</h3>
                    <div v-html="description"></div>
                </div>
            </div>
        </div>


        <div v-if="quote" class="financial-details">

            <div class="row">
                <div class="col-12">

                    <h3>{{ fundingAgreementTitle }}</h3>

                    <div v-if="quote">
                        <div class="">
                            <span class="key">Contract Term</span>
                            <span class="ms-2 value">
                                <strong>{{ term }} Months</strong>
                            </span>
                        </div>
                        <div class="">
                            <span class="key">Mileage</span>
                            <span class="ms-2 value">
                                <strong>{{ annualMileage }}</strong>
                            </span>
                        </div>
                        <div class="">
                            <span class="key">Monthly Vehicle Payment</span>
                            <span class="ms-2 value">
                                <strong>{{ vehiclePayment }}</strong>
                            </span>
                        </div>
                    </div>

                    <div class="agree mb-0">
                        <input type="checkbox" name="confirm_1" id="confirm_1"
                               v-model="confirmations.creditSaleDetails" class="confirm">
                        <label for="confirm_1">
                            {{ fundingAgreementDeclaration }}
                        </label>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-12">

                    <h3>{{ salaryDeductionsTitle }}</h3>
                    <p>{{ salaryDeductionsDescription }}</p>

                    <div>
                        <span class="key">Scheme Insurances</span><span
                        class="ms-2 value"><strong>{{ insurance }}</strong></span>
                    </div>

                    <div class="agree mb-0">
                        <input type="checkbox" name="confirm_2" id="confirm_2"
                               v-model="confirmations.furtherSalaryDeductions" class="confirm">
                        <label for="confirm_2">{{ salaryDeductionsDeclaration }}</label>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-12">

                    <h3>{{ maintenanceTitle }}</h3>
                    <p>{{ maintenanceDescription }}</p>

                    <h4>{{ maintenanceKeyPointsHeading }}</h4>
                    <div v-html="maintenanceKeyPoints"></div>

                    <div class="agree mb-0">
                        <input type="checkbox" name="confirm_3" id="confirm_3"
                               v-model="confirmations.fullVehicleMaintenance" class="confirm">
                        <label for="confirm_3">{{ maintenanceDeclarationText }}</label>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-12">

                    <h3>{{ insuranceAccidentDamageTitle }}</h3>
                    <p>{{ insuranceAccidentDamageDescription }}</p>

                    <h4>{{ insuranceAccidentDamageKeyPointsHeading }}</h4>
                    <div v-html="insuranceAccidentDamageKeyPoints"></div>

                    <div class="agree mb-0">
                        <input type="checkbox" name="confirm_4" id="confirm_4"
                               v-model="confirmations.motorInsuranceProduct" class="confirm">
                        <label for="confirm_4">{{ insuranceAccidentDamageDeclarationText }}</label>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-12">

                    <h3>{{ schemePolicyTitle }}</h3>
                    <p>{{ schemePolicyDescription }}</p>

                    <h4>{{ schemePolicyKeyPointsHeading }}</h4>
                    <div v-html="schemePolicyKeyPoints"></div>

                    <div class="agree mb-0">
                        <input type="checkbox" name="confirm_5" id="confirm_5"
                               v-model="confirmations.schemePolicy" class="confirm">
                        <label for="confirm_5">{{ schemePolicyDeclarationText }}</label>
                    </div>

                </div>
            </div>

        </div>
    </div>

</template>

<script>
import {EventBus} from '@/event-bus.js';

export default {

    props: [
        'session',
        'submit-order',
        'confirmations',
        'quote',
        'driverProfile',
        'adminPortalData',
        'sectionThreeHeading',
    ],

    data: () => {
        return {};
    },

    async beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        }

        // This is called again when we do the order ID redirect after the order is confirmed so filter those out
        if (to.name === 'ECO / AMAPS Order Status' && !to.params.orderId) {
            //document.getElementById('order-process-wrap').scrollTo({top: 0, behavior: 'smooth'});

            /*if (
                !this.confirmations.creditSaleDetails ||
                !this.confirmations.furtherSalaryDeductions ||
                !this.confirmations.fullVehicleMaintenance ||
                !this.confirmations.motorInsuranceProduct ||
                //!this.confirmations.earlyTerminationInsurance ||
                !this.confirmations.schemePolicy
            ) {
                EventBus.$emit('showError', true);
                EventBus.$emit('errorTitle', 'Please confirm all points to continue');
                EventBus.$emit('errorMessage', '');
                return false;
            }*/

            EventBus.$emit('loadingTitle', 'Submitting Order');
            EventBus.$emit('loading', true);

            // Submit the order
            this.$http.post('/api/quotation', {
                    method: 'POST',
                    endpoint: 'orders',
                    body_params: {
                        customerOrderRef: this.driverProfile.driverID + '-' + Date.now(),
                        quotes: [
                            {
                                quoteID: this.quote.quoteID,
                                quantity: 1
                            }
                        ]
                    }
                })
                .then(response => {

                    const orderId = response.data.data[0].orderID;

                    // Trigger the notification
                    this.$http.post('/api/notifications/send-order', {
                            orderId: orderId
                        })
                        .then(response => {
                            EventBus.$emit('loading', false);

                            this.$router.push({ name: 'Order Status', params: { orderId: orderId } })

                            next();
                        })
                        .catch(err => {
                            EventBus.$emit('loading', false);
                            let response = err.response.data;

                            this.$notify({
                                group: 'notify',
                                type: 'error',
                                title: 'Error',
                                text: response.message
                            });
                            this.error = err.message.toString();
                            this.$router.push({name: response.redirect, params: {...this.$route.params}});
                        });

                })
                .catch(err => {
                    EventBus.$emit('loading', false);
                    let response = err.response.data;

                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: 'Error',
                        text: response.message
                    });
                    this.error = err.message.toString();
                    this.$router.push({name: response.redirect, params: {...this.$route.params}});
                });

        } else {
            next();
        }
    },

    // computed: {
    //     financials() {
    //         return {
    //             contractTerm: this.order.quote.definition.plan.term,
    //             mileage: this.order.quote.details.plan.lifeDistance.toLocaleString(),
    //             monthlyVehiclePayment: this.monthlyVehiclePayment,
    //             schemeInsurance: (Number(this.order.quote.taxCalculations.employeeCostPrivateCar.motoringAndFinance_InsuranceCost) / this.order.quote.definition.plan.term).toFixed(2)
    //         }
    //     },
    //     monthlyVehiclePayment() {
    //         const rentalsPayment = Number(this.order.quote.taxCalculations.employeeCostPrivateCar.motoringAndFinance_RentalsPayments);
    //         const maintenanceCost = Number(this.order.quote.taxCalculations.employeeCostPrivateCar.motoringAndFinance_MaintenanceCost);
    //         return Number((rentalsPayment + maintenanceCost) / this.order.quote.definition.plan.term).toFixed(2);
    //     },
    // },

    methods: {
        getInCurrency(value, currency = '£') {
            return currency + Number(value).toFixed(2);
        },
    },

    computed: {
        term() {
            if (this.quote.term !== undefined) {
                return this.quote.term;
            }
            return this.quote.definition.plan.term;
        },
        annualMileage() {
            return this.quote?.definition?.plan?.annualDistance;
        },
        insurance() {
          return this.getInCurrency(Number(this.quote.taxCalculations.employeeCostPrivateCar.motoringAndFinance_InsuranceCost) / Number(this.quote.definition.plan.term));
        },
        vehiclePayment() {
            return this.getInCurrency(Number(this.quote.details.pricing.totalIncVAT).toFixed(2));
        },
        description() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_section_three_description : '';
        },
        fundingAgreementDeclaration() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_funding_agreement_declaration : '';
        },
        fundingAgreementTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_funding_agreement_title : '';
        },
        insuranceAccidentDamageDeclarationText() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_insurance_accident_damage_declaration_text : '';
        },
        insuranceAccidentDamageDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_insurance_accident_damage_description : '';
        },
        insuranceAccidentDamageKeyPoints() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_insurance_accident_damage_key_points : '';
        },
        insuranceAccidentDamageKeyPointsHeading() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_insurance_accident_damage_key_points_heading : '';
        },
        insuranceAccidentDamageTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_insurance_accident_damage_title : '';
        },
        maintenanceDeclarationText() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_maintenance_declaration_text : '';
        },
        maintenanceDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_maintenance_description : '';
        },
        maintenanceKeyPoints() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_maintenance_key_points : '';
        },
        maintenanceKeyPointsHeading() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_maintenance_key_points_heading : '';
        },
        maintenanceTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_maintenance_title : '';
        },
        salaryDeductionsDeclaration() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_salary_deductions_declaration : '';
        },
        salaryDeductionsDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_salary_deductions_description : '';
        },
        salaryDeductionsTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_salary_deductions_title : '';
        },
        schemePolicyDeclarationText() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_scheme_policy_declaration_text : '';
        },
        schemePolicyDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_scheme_policy_description : '';
        },
        schemePolicyKeyPoints() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_scheme_policy_key_points : '';
        },
        schemePolicyKeyPointsHeading() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_scheme_policy_key_points_heading : '';
        },
        schemePolicyTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_scheme_policy_title : '';
        },
        sectionThreeDescription() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_section_three_description : '';
        },
        sectionThreeTitle() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_three_section_three_title : '';
        },
    },
    watch: {
        confirmations: {
            handler(confirmations) {
              EventBus.$emit('setConfirmations', confirmations);
            },
            deep: true,
        },
    },
};
</script>


